import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { TrendingUp, Clock } from 'lucide-react';
import { JURISDICTION_NAMES } from '../../lib/constants';
import { JURISDICTION_FLAGS, formatDate, getScoreColor } from './adminUtils';

export const OverviewTab = ({ analytics }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="admin-overview-tab">
    {/* Average Scores by Jurisdiction */}
    <Card className="bg-slate-800/50 border-slate-700">
      <CardContent className="p-6">
        <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-[#3B82F6]" />
          Average Scores by Jurisdiction
        </h3>
        <div className="space-y-4">
          {Object.entries(analytics?.average_scores || {}).map(([jur, score]) => (
            <div key={jur} className="flex items-center gap-4">
              <span className="text-2xl">{JURISDICTION_FLAGS[jur]}</span>
              <div className="flex-1">
                <div className="flex justify-between mb-1">
                  <span className="text-slate-300">{JURISDICTION_NAMES[jur] || jur}</span>
                  <span className="text-white font-semibold">{score}%</span>
                </div>
                <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
                  <div
                    className={`h-full rounded-full ${score >= 80 ? 'bg-[#10B981]' : score >= 50 ? 'bg-[#F59E0B]' : 'bg-[#EF4444]'}`}
                    style={{ width: `${score}%` }}
                  />
                </div>
              </div>
              <span className="text-slate-500 text-sm">
                ({analytics?.by_jurisdiction?.[jur] || 0} completed)
              </span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>

    {/* Recent Activity */}
    <Card className="bg-slate-800/50 border-slate-700">
      <CardContent className="p-6">
        <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
          <Clock className="h-5 w-5 text-[#3B82F6]" />
          Recent Completed Assessments
        </h3>
        <div className="space-y-3">
          {analytics?.recent_activity?.length === 0 ? (
            <p className="text-slate-500 text-center py-4">No completed assessments yet</p>
          ) : (
            analytics?.recent_activity?.map((item) => (
              <div
                key={item.assessment_id}
                className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">{JURISDICTION_FLAGS[item.jurisdiction]}</span>
                  <div>
                    <p className="text-white font-medium">{item.company_name}</p>
                    <p className="text-slate-500 text-xs">{formatDate(item.completed_at)}</p>
                  </div>
                </div>
                <Badge className={getScoreColor(item.score >= 80 ? 'high' : item.score >= 50 ? 'medium' : 'low')}>
                  {item.score}%
                </Badge>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  </div>
);
